import angular from 'angular';
import 'angular-bootstrap';
import 'ui-select';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module';
import 'angular-bootstrap-colorpicker/css/colorpicker.css';
import './themesServices'

const themesControllers = angular.module('applicationModule.themesControllers', [
    'applicationModule.themesServices',
    'colorpicker.module',
    'ui.bootstrap'
]);

themesControllers.controller('ThemesController', ['$scope', '$rootScope', '$stateParams', '$filter', '$state', 'NgTableParams', 'Theme', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $filter, $state, NgTableParams, Theme, growl, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('themes');
    $scope.app_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Theme.getList($scope.app_id, params._params).then(function (response) {
                params.count(response.themes.perPage);
                params.page(response.themes.currentPage);
                $scope.packageId = response.packageId;
                return response.themes;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeTheme = function (id) {
        Theme.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.THEMES.SUCCESS.DELETE');
                $scope.tableParams.reload();
            } else {
                growl.error('MODULES.THEMES.ERROR.DELETE');
            }
        });
    };
}]);

themesControllers.controller('ThemeController', ['$scope', '$rootScope', '$stateParams', '$filter', '$state', 'NgTableParams', 'Theme', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $filter, $state, NgTableParams, Theme, growl, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('themes');

    const appId = $stateParams.application_id;
    const themeId = $stateParams.themeId;

    $scope.editMode = false;
    $scope.theme = {
        app_id: appId
    };

    $scope.format = 'yyyy-MM-dd';

    if (angular.isDefined(themeId)) {
        $scope.editMode = true;
        $scope.isLoading = true;

        Theme.get(themeId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.theme = data.theme;
            } else {
                growl.error('MODULES.THEMES.ERROR.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.themes', {applicationId: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    } else {
        const today = new Date();
        $scope.theme.fromDate = $filter('date')(today.getTime(), 'yyyy-MM-dd');
        $scope.theme.toDate = $filter('date')(today.getTime(), 'yyyy-MM-dd');
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.themeForm.$valid) {
            $scope.isLoading = true;
            Theme.save($scope.theme, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.THEMES.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $state.go('appsoup.application.themes', {applicationId: appId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.THEMES.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.$watch('theme.fromDate', function (newVal, val) {
        if (angular.isDefined(newVal) && val !== newVal) {
            $scope.theme.fromDate = $filter('date')(newVal, 'yyyy-MM-dd');
        }
    }, true);

    $scope.$watch('theme.toDate', function (newVal, val) {
        if (angular.isDefined(newVal) && val !== newVal) {
            $scope.theme.toDate = $filter('date')(newVal, 'yyyy-MM-dd');
        }
    }, true);

    $scope.cancel = function () {
        $state.go('appsoup.application.themes', {applicationId: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.THEMES.ERROR.REQUIRE.NAME'}],
        'placement': [{type: '$invalid', msg: 'MODULES.THEMES.ERROR.REQUIRE.PLACEMENT'}],
        'animation': [{error: 'pattern', msg: 'MODULES.THEMES.ERROR.ANIMATION'}]
    };
}]);

export default themesControllers;
